export default "__VITE_ASSET__CV89fhmF__"